import { render, staticRenderFns } from "./ModalDescriptionFile.html?vue&type=template&id=aae0feac&scoped=true&"
import script from "./ModalDescriptionFile.vue?vue&type=script&lang=js&"
export * from "./ModalDescriptionFile.vue?vue&type=script&lang=js&"
import style0 from "./ModalDescriptionFile.scss?vue&type=style&index=0&id=aae0feac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae0feac",
  null
  
)

export default component.exports